import React from 'react';

// External Components
import { Box } from '@thepuzzlers/pieces';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export const ImageContainer = ({
  designatedRef,
  className = '',
  src,
  alt,
  sx,
  imageSx,
  imgProps,
  imgStyle,
  children,
  image,
  ...props
}) => {
  return (
    <Box
      ref={designatedRef}
      className={`image-container ${className}`}
      sx={{
        overflow: 'hidden',
        position: 'relative',
        '& img': {
          borderRadius: 'card'
        },
        ...sx
      }}
      {...props}>
      <GatsbyImage
        className="gatsby-image"
        {...imgProps}
        image={src ? getImage(src) : image}
        alt={alt || ''}
        style={{ height: '100%', width: '100%', ...imageSx }}
        imgStyle={imgStyle}
      />
      {children}
    </Box>
  );
};
